import firebase from "firebase";
import {bind, defer} from 'lodash';
import ActiveService from '@/service.active';

const API_URL = process.env.API_URL || 'http://localhost:3000';

function getServiceName(uri) {
	const services = {
		'bookings': '$bookings',
		'users': '$users',
		'bookings-limit-left': 'bookingLimitComponent'
	};
	let result;
	uri.split('/').filter(part => {
		if (services[part]) {
			result = services[part];
		}
	});
	return result;
}

export default class ActiveChannel extends ActiveService {

	constructor($injector,
	            $timeout,
	            $rootScope) {

		'ngInject';

		super($injector);

		this.$timeout = $timeout;
		this.$rootScope = $rootScope;

		this.waitingForNewChannel = false;

		this.init();

	}

	init() {
		try {
			this.user = this.cacheGet("user");
			if (this.user) {
				this.$http
					.get(`${API_URL}/api/firebase-config`)
					.then(response => {
						const firebase_config = response.data;
						if (!firebase_config.firebaseActive) {
							this.token = this.user.channel_token;
							this.channelRequestUri = this.user.uris.Channel;
							defer(() => {
								if (this.token) {
									this.reconnectChannel();
								} else {
									this.getToken();
								}
							});
						} else {
							this.connectFirebase(firebase_config, this.user.uris.FirebaseData);
						}
					});

			}
		} catch (e) {
			console.log(e);
			setTimeout(() => this.init(), 2500);
		}
	}

	onOpen() {
		if (window.isChannelDebug) {
			console.log("Opened Channel API channel", Array.prototype.slice.call(arguments));
		}
	}

	onMessage(message) {

		console.log("Message Channel from API channel", Array.prototype.slice.call(arguments));
		
		if (window.isChannelDebug) {
			console.log("Message Channel from API channel", Array.prototype.slice.call(arguments));
		}

		const data = JSON.parse(message.data);

		this.$rootScope.$emit(`${getServiceName(data.uri)}Update`, data);
	}

	onError(error) {
		if (window.isChannelDebug) {
			console.error("Error in Channel API channel", Array.prototype.slice.call(arguments));
		}
		if (!this.waitingForNewChannel) {
			if (this.socket) {
				this.socket.close();
			}

			this.getNewChannelToken();
		}
	}

	onClose() {
		if (window.isChannelDebug) {
			console.error("Closed Channel API channel", Array.prototype.slice.call(arguments));
		}
		if (!this.waitingForNewChannel) {
			this.getNewChannelToken();
		}
	}

	getNewChannelTokenRequest() {
		if (window.isChannelDebug) {
			console.log('### Trying to reconnect Channel...');
		}
		this.waitingForNewChannel = true;
		this.activePost(this.channelRequestUri, {})
			.then(response => {
				this.token = response.channel_token;
				this.cacheUpdate('user', 'channel_token', this.token);
				this.reconnectChannel();
			})
			.catch(e => {
				if (window.isChannelDebug) {
					console.log('### Timed out... retry in 5sec');
				}
				this.$timeout(() => this.getNewChannelTokenRequest(), 5000);
			});
	}

	getNewChannelToken() {
		this.waitingForNewChannel = true;
		this.getNewChannelTokenRequest();
	}

	reconnectChannel() {

		if (!this.token) {
			this.getNewChannelToken();
		}

		try {
			if (window.isChannelDebug) {
				console.log('### Channel reconnect - %s', this.token);
			}
			this.channel = new goog.appengine.Channel(this.token);
			this.socket = this.channel.open();
			this.socket.onopen = bind(this.onOpen, this);
			this.socket.onmessage = bind(this.onMessage, this);
			this.socket.onerror = bind(this.onError, this);
			this.socket.onclose = bind(this.onClose, this);
		} catch (e) {
		}

	}

	connectFirebase(firebase_config, FirebaseDataUri) {

		return this.$http.get(`${API_URL}${FirebaseDataUri}`)
			.then(firebase_data => {

				const data = firebase_data.data;

				const handleError = () => this.connectFirebase(firebase_config);

				const connectDatabase = () => {

					const connectionsRef = firebase.database().ref(data.connection_path);
					const channelRef = firebase.database().ref(data.channel_path);
					const connectedRef = firebase.database().ref(".info/connected");

					connectedRef.on("value", (snap) => {
						if (snap.val() === true) {
							const con = connectionsRef.push();
							con.onDisconnect().remove();
							con.set(firebase.database.ServerValue.TIMESTAMP);
						}
					});

					return channelRef.on("value", (data) => {
						if (null === data.val()) return false;
						return this.onMessage({data: data.val()});
					});

				};

				if (!firebase.apps.length) {
					firebase.initializeApp(firebase_config);
				}

				firebase.auth().signInWithCustomToken(data.auth_token)
					.then(user => connectDatabase(user))
					.catch(error => handleError(error));
			});


	}



}




/** WEBPACK FOOTER **
 ** ./frontend/@/channel.active.js
 **/